// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Analytics
import { intercomTrackEvent } from '../../../../analytics/intercomService';
import { sendAmplitudeEvent } from '../../../../analytics/amplitudeService';

// Components
import ImageModalEditor from './ImageModalEditor';

// Constants
import { EVENT_TYPE_NAMES } from '../../../../../common/analytics/amplitudeEventTypesUtil';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../../../../common/analytics/statsConstants';

const ImageModalCropModeContent = (props) => {
    const { finishEditingMode } = props;

    // close editor after short delay to allow image changes to propagate and render
    const closeEditorCallback = () => {
        intercomTrackEvent('edited-image');

        sendAmplitudeEvent({
            eventType: EVENT_TYPE_NAMES.EDITED_IMAGE,
            userProperties: {
                [AMPLITUDE_USER_PROPS.FEATURE]: { [TRACKED_FEATURES.IMAGE_EDITOR]: true },
            },
        });

        setTimeout(finishEditingMode, 50);
    };

    return <ImageModalEditor {...props} cancelEditing={finishEditingMode} afterSaveCb={closeEditorCallback} />;
};

ImageModalCropModeContent.propTypes = {
    finishEditingMode: PropTypes.func,
};

export default ImageModalCropModeContent;
